// PrivateRoute.tsx in v6
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../../features/authentication/utils/auth';

const SpecialRoute = ({ children }) => {
	const location = useLocation();

	if (isLoggedIn()) {
		return <Navigate to="/" state={{ from: location }} />;
	}

	return children;
};

SpecialRoute.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

export default SpecialRoute;
